import { RouteParam } from "../../../routes";
import { ACTION, MODULE } from "../../../utils/enums";
import { urls } from "../../../utils/urls";
import NPDCreateScreen from "../NPD/components/npd_create_screen";
import NPDFinalViewScreen from "../NPD/components/npd_final_review";
import NPDInwardScreen from "../NPD/components/npd_inward_screen";
import NPDListScreen from "../NPD/new_product_dev_list";

const ndp_routes: RouteParam[] = [
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.npd,
    component: NPDListScreen,
    module: MODULE.NPD,
    main_module: MODULE.procurement_panel,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.npd + "/create",
    component: NPDCreateScreen,
    module: MODULE.NPD,
    main_module: MODULE.procurement_panel,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.npd + "/update/:id",
    component: NPDCreateScreen,
    module: MODULE.NPD,
    main_module: MODULE.procurement_panel,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.npd + "/view/:id",
    component: NPDFinalViewScreen,
    module: MODULE.NPD,
    main_module: MODULE.procurement_panel,
    action: [ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.npd + "/inward/:id",
    component: NPDInwardScreen,
    module: MODULE.NPD,
    main_module: MODULE.procurement_panel,
    action: [ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
];

export default ndp_routes;
